// ============================================================
//  src/pages/pin/PinPage.js
// ============================================================
import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { postRequestPinCode, postUpdatePin } from '../../api/client';
import { getError } from '../../utils/helpers';
import PageHeader from '../../components/layout/PageHeader';
import './PinPage.css';

export default function PinPage() {
  const [step, setStep]     = useState(1);
  const [form, setForm]     = useState({ code: '', new_pin: '', confirm_pin: '' });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm((p) => ({ ...p, [k]: e.target.value }));

  const requestCode = async () => {
    setLoading(true);
    try {
      const { data: res } = await postRequestPinCode();
      if (res.status === 'success') { toast.success(res.msg || 'Code sent to your email.'); setStep(2); }
      else toast.error(res.msg || 'Failed to send code.');
    } catch (err) { toast.error(getError(err)); }
    finally { setLoading(false); }
  };

  const updatePin = async (e) => {
    e.preventDefault();
    if (!form.code || !form.new_pin || !form.confirm_pin) { toast.error('Fill all fields.'); return; }
    if (form.new_pin !== form.confirm_pin) { toast.error('PINs do not match.'); return; }
    setLoading(true);
    try {
      const { data: res } = await postUpdatePin(form);
      if (res.status === 'success') {
        toast.success('PIN updated successfully!');
        setStep(1); setForm({ code: '', new_pin: '', confirm_pin: '' });
      } else toast.error(res.msg || 'Update failed.');
    } catch (err) { toast.error(getError(err)); }
    finally { setLoading(false); }
  };

  return (
    <>
      <PageHeader title="Manage PIN" icon="fa-key" />
      <div className="pin-page a a1">

        <div className="pin-info-banner">
          <i className="fas fa-lock pin-info-icon" />
          <div>
            <b>Transaction PIN</b>
            <p>Your 5-digit PIN is required to authorise all transactions and transfers.</p>
          </div>
        </div>

        {step === 1 && (
          <div className="page-card a a2">
            <div className="page-card-hdr"><h3>Change Transaction PIN</h3></div>
            <div className="page-card-body">
              <p style={{ fontSize: 13.5, color: 'var(--text-muted)', marginBottom: 20, fontWeight: 500, lineHeight: 1.6 }}>
                We'll send a verification code to your registered email address. Enter it along with your new PIN on the next step.
              </p>
              <button className="btn btn-primary btn-full btn-md" onClick={requestCode} disabled={loading}>
                {loading ? <><span className="spinner" /> Sending code…</> : <><i className="fas fa-paper-plane" /> Send Verification Code</>}
              </button>
            </div>
          </div>
        )}

        {step === 2 && (
          <div className="page-card a a2">
            <div className="page-card-hdr"><h3>Enter New PIN</h3></div>
            <div className="page-card-body">
              <form onSubmit={updatePin}>
                <div className="svc-field">
                  <label className="form-label">Verification Code</label>
                  <input className="form-control" type="text" placeholder="Code from email" maxLength={6} inputMode="numeric" value={form.code} onChange={set('code')} />
                </div>
                <div className="svc-field">
                  <label className="form-label">New PIN (5 digits)</label>
                  <input className="form-control" type="password" placeholder="•••••" maxLength={5} inputMode="numeric" value={form.new_pin} onChange={set('new_pin')} />
                </div>
                <div className="svc-field">
                  <label className="form-label">Confirm New PIN</label>
                  <input className="form-control" type="password" placeholder="•••••" maxLength={5} inputMode="numeric" value={form.confirm_pin} onChange={set('confirm_pin')} />
                </div>
                <button type="submit" className="btn btn-primary btn-full btn-md" disabled={loading}>
                  {loading ? <><span className="spinner" /> Updating…</> : <><i className="fas fa-key" /> Update PIN</>}
                </button>
                <button type="button" className="btn btn-ghost btn-full btn-md" style={{ marginTop: 8 }} onClick={() => setStep(1)}>
                  ← Resend Code
                </button>
              </form>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
